import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  enabled: false,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')

    return systemSettingApi.getDeliveryLogSetting()
      .then(({ data }) => commit('DELIVERY_LOG_SETTING_FETCHED', data))
      .catch(err => commit('DELIVERY_LOG_SETTING_FETCH_FAILED', err))
  },
  update({ commit }) {
    return systemSettingApi.updateDeliveryLogSetting({ enabled: state.enabled })
      .then(() => commit('DELIVERY_LOG_SETTING_UPDATED'))
      .catch(error => {
        commit('DELIVERY_LOG_SETTING_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  DELIVERY_LOG_SETTING_FETCHED(state, data) {
    state.enabled = data.enabled
  },
  DELIVERY_LOG_SETTING_FETCH_FAILED() {
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  DELIVERY_LOG_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  DELIVERY_LOG_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
